import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import {
    AccordionDetails,
    AccordionSummary,
    IconButton,
    Accordion as MUIAccordion,
    Typography
} from '@mui/material'
import { color } from 'config/color'
import type React from 'react'
import { useState } from 'react'
import { useMobileBreakpoints } from 'utils/hooks/useMobileBreakpoints'

interface AccordionProps {
    key?: number
    title: string
    children?: React.ReactNode
}

const Accordion: React.FC<AccordionProps> = (props: AccordionProps) => {
    const [expanded, setExpanded] = useState<boolean>(true)
    const isMobile = useMobileBreakpoints()
    const handleChange = (): void => {
        setExpanded(!expanded)
    }
    return (
        <MUIAccordion
            expanded={expanded}
            onChange={handleChange}
            sx={{
                backgroundColor: color.background[50],
                width: '100%'
            }}
        >
            <AccordionSummary
                expandIcon={
                    <IconButton
                        size="small"
                        sx={{
                            display: 'flex',
                            bgcolor: color.grey[200],
                            '&:hover': { opacity: 1, bgcolor: color.grey[200] }
                        }}
                    >
                        {expanded
                            ? (<RemoveIcon sx={{ color: color.primary[600] }} />)
                            : (<AddIcon sx={{ color: color.primary[600] }} />)}
                    </IconButton>
                }
            >
                <Typography color={color.grey[900]} fontSize={isMobile ? 14 : 16} mr={2} p={isMobile ? 0 : 1}>
                    {props.title}
                </Typography>
            </AccordionSummary>
            <AccordionDetails
                sx={{
                    background: color.white,
                    py: 2,
                    px: 3,
                    borderLeft: `solid 4px ${color.primary[500]}`,
                    '.accordion-link': {
                        color: color.background[900]
                    },
                    ul: {
                        paddingLeft: '0'
                    },
                    '.accordion-list': {
                        listStyleType: 'none',
                        padding: '0'
                    },
                    '.accordion-list::before': {
                        content: "''",
                        display: 'inline-block',
                        width: '10px',
                        height: '10px',
                        borderRadius: '50%',
                        backgroundColor: color.primary[500],
                        marginRight: '8px'
                    }
                }}
            >
                {props.children}

            </AccordionDetails>
        </MUIAccordion >
    )
}

export default Accordion
